import { ResizeHandler } from '../../_modules/resize_handler/resize_handler';
import Swiper from 'swiper';

export const initializeSlider = () => {
    new Swiper('.slider', {
        centeredSlides: true,
        spaceBetween: 30,
        slidesPerView: (!$('.fitter-slider__slider-section-content').length || window.innerWidth < 1024 ? 'auto' : (window.innerWidth >= 1400 ? 3 : 2)),
        roundLengths: true,
        loop: false,
        paginationClickable: true,
        pagination: '.slider-control--pagination',
        autoplay: $('.slider.no-auto-slide').length ? false : 4500,
        prevButton: '.slider-control--prev',
        nextButton: '.slider-control--next',
        onInit: () =>
            $('.swiper-slide')
                .filter(':not(.swiper-slide-active)')
                .find('.slide__link')
                .attr('disabled', 'disabled'),
        onSlideChangeEnd: swiper => {
            $('.slide__link', swiper.slides[swiper.previousIndex]).attr('disabled', 'disabled');
            $('.slide__link', swiper.slides[swiper.activeIndex]).removeAttr('disabled');
        }
    });

    ResizeHandler.subscribe(() => $('.slider__slide').eqHeight());
    $('.slider__slide').eqHeight();
};
